import { render, staticRenderFns } from "./ApperanceScheme.vue?vue&type=template&id=6266898d&scoped=true"
import script from "./ApperanceScheme.vue?vue&type=script&lang=js"
export * from "./ApperanceScheme.vue?vue&type=script&lang=js"
import style0 from "./ApperanceScheme.vue?vue&type=style&index=0&id=6266898d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6266898d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6266898d')) {
      api.createRecord('6266898d', component.options)
    } else {
      api.reload('6266898d', component.options)
    }
    module.hot.accept("./ApperanceScheme.vue?vue&type=template&id=6266898d&scoped=true", function () {
      api.rerender('6266898d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/OrganisationDetails/Settings/ApperanceScheme.vue"
export default component.exports